module.exports = __webpack_public_path__ + "assets/img/tiyan2.d8e93a00.png";